import React from 'react';
export function ExpertSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 border-t border-border-light/50" data-id="element-112">
      <div className="max-w-3xl mx-auto text-center" data-id="element-113">
        <div className="w-28 h-28 bg-gradient-to-br from-primary to-secondary rounded-full mx-auto flex items-center justify-center text-5xl shadow-[0_0_30px_rgba(30,142,90,0.3)] mb-8 border-4 border-bg-dark relative" data-id="element-114">
          <div className="absolute inset-0 rounded-full border-2 border-white/30" data-id="element-115"></div>
          🧬
        </div>

        <h2 className="text-3xl sm:text-4xl font-montserrat font-black text-text-main mb-8 tracking-tight" data-id="element-116">
          A proposito di EduLabs Italia
        </h2>

        <div className="relative" data-id="element-117">
          <span className="absolute -top-6 -left-4 text-6xl text-primary/20 font-serif" data-id="element-118">
            "
          </span>
          <p className="text-text-main text-xl sm:text-2xl leading-relaxed italic font-medium relative z-10" data-id="element-119">
            Abbiamo creato BIOLOGIA PRONTA™ per aiutare i docenti italiani a
            insegnare biologia in modo moderno, visuale e coinvolgente.
            Strumenti pratici per riportare la passione in aula.
          </p>
          <span className="absolute -bottom-10 -right-4 text-6xl text-primary/20 font-serif" data-id="element-120">
            "
          </span>
        </div>
      </div>
    </section>;
}